interface ContentItemBase {
  type: string;
}

interface HeadingItem extends ContentItemBase {
  type: 'h2';
  content: string;
}

interface ParagraphItem extends ContentItemBase {
  type: 'p';
  content: string;
}

interface ListItem extends ContentItemBase {
  type: 'ol' | 'ul';
  content: ContentItem[];
}

interface ListItemElement extends ContentItemBase {
  type: 'li';
  content: string | ContentItem[];
}

export type ContentItem = HeadingItem | ParagraphItem | ListItem | ListItemElement;

export const renderContent = (item: ContentItem, index: number = 0): React.ReactNode => {
  switch (item.type) {
    case 'h2':
      return (
        <h2
          key={index}
          className="text-xl font-bold text-gray-900 mb-3"
        >
          {item.content}
        </h2>
      );

    case 'p':
      return (
        <p
          key={index}
          className="text-gray-700 mb-3 leading-relaxed inline ml-4"
        >
          {item.content}
        </p>
      );

    case 'ol':
      return (
        <ol
          key={index}
          className="list-decimal list-inside space-y-2 mb-4 ml-4"
        >
          {item.content.map((child, i) => renderContent(child, i))}
        </ol>
      );

    case 'ul':
      return (
        <ul
          key={index}
          className="list-disc list-inside space-y-2 mb-4 ml-4"
        >
          {item.content.map((child, i) => renderContent(child, i))}
        </ul>
      );

    case 'li':
      if (typeof item.content === 'string') {
        return (
          <li
            key={index}
            className="text-gray-700 leading-relaxed"
          >
            {item.content}
          </li>
        );
      }
      return (
        <li
          key={index}
          className="text-gray-700 leading-relaxed"
        >
          {Array.isArray(item.content) &&
            item.content.map((child, i) => renderContent(child, i))}
        </li>
      );

    default:
      return null;
  }
};
